<template>
  <div id="app">
    <HeadSection />
    <div class="center">
      <LeftNavigation />
      <section>
        <router-view/>
      </section>
      <AsideSection />
      <modal name="imgDetail">        
        <div class="modalContent">
          <div slot="top-right" class="ct-top-right">
            <button @click="$modal.hide('imgDetail')">
              ❌
            </button>
          </div>
          <img v-bind:src="imgPath">
          <div class="imgText">{{imgText}}</div>
        </div>
      </modal>
    </div>
    <FootSection />
  </div>
</template>

<script>
/* @ is an alias to /src */
import HeadSection from '@/components/HeadSection.vue';
import LeftNavigation from '@/components/LeftNavigation.vue';
import AsideSection from '@/components/AsideSection.vue';
import FootSection from '@/components/FootSection.vue';
import JQuery from 'jquery'
var $ = JQuery

export default {
  name: 'app',
  components: {
    HeadSection,
    LeftNavigation,
    AsideSection,
    FootSection
  },
  data(){
    return{
      imgPath: "http://www.foto-romania.de/fotos/revo_1.jpg",
      imgText: "Romania, Rumänien",
      imgName: ''
    }
  },
  methods: {
    handleImageClick: function(imgText, imgName, event) {
      this.imgPath = "http://www.foto-romania.de/fotos/" + imgName;
      this.imgText = imgText;
      this.$modal.show('imgDetail');
    },
    hideImageClick() {
      this.$modal.hide('imgDetail');
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      $(document).ready(function(){
		    $("#menuOpen").click(function(){
          if ($("#menuOpen").hasClass("mobMenuOpen")) {
            $("#app div.center nav").attr("style", "display: none;")
            $("#menuOpen").removeClass("mobMenuOpen");
          } else {
            $("#app div.center nav").attr("style", "display: block;")
            $("#menuOpen").addClass("mobMenuOpen");
          }
         
        });
        $(".center nav #nav").click(function(){
          if ($("#menuOpen").hasClass("mobMenuOpen")) {
            $("#app div.center nav").attr("style", "display: none;")
            $("#menuOpen").removeClass("mobMenuOpen");
          }
        });
		  });
    });
  }
}
</script>

<style lang="scss">
@import '../public/style.scss'
</style>